import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.app;

export const reservesSelector = createSelector(getState, (state) => state.reserves);
export const isLoadingReservesSelector = createSelector(
  getState,
  (state) => state.isLoadingReserves,
);

export const exchangeDirectionsSelector = createSelector(
  getState,
  (state) => state.exchangeDirections,
);
export const exchangeDirectionsMetaSelector = createSelector(
  getState,
  (state) => state.exchangeDirectionsMeta,
);
export const isLoadingExchangeDirectionsSelector = createSelector(
  getState,
  (state) => state.isLoadingExchangeDirections,
);

export const contactUsErrorsSelector = createSelector(getState, (state) => state.contactUsErrors);
